import { createRoot } from 'react-dom/client';
import ProcessSteps from '@/components/education/ProcessSteps';

export const usePrintProcessSteps = () => {
  const printProcessSteps = () => {
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    
    if (!printWindow) {
      alert('Please allow popups to print the process steps');
      return;
    }

    // Set up the print window
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>3-Step Note Investing Process</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 0; 
              padding: 20px; 
              background: white;
              line-height: 1.6;
            }
            @media print {
              body { margin: 0; padding: 10px; }
              .no-print { display: none; }
            }
            .print-header {
              text-align: center;
              margin-bottom: 30px;
              border-bottom: 2px solid #1e40af;
              padding-bottom: 20px;
            }
            .print-header h1 {
              color: #1e40af;
              margin: 0;
              font-size: 28px;
            }
            .print-header p {
              color: #6b7280;
              margin: 10px 0 0 0;
              font-size: 16px;
            }
          </style>
        </head>
        <body>
          <div class="print-header">
            <h1>3-Step Note Investing Process</h1>
            <p>How Smart Investors Create Superior Returns with Land Contracts</p>
          </div>
          <div id="print-content"></div>
          <script>
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
    
    // Render the ProcessSteps component
    const printContent = printWindow.document.getElementById('print-content');
    if (printContent) {
      const root = createRoot(printContent);
      root.render(<ProcessSteps />);
    }
  };

  return { printProcessSteps };
};